<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <template v-if="isLoad">
                <b-card class="mb-4" title="예약 가능 인원 설정">
                    <b-table id="table-transition-example" :items="items" :fields="fields" striped small class="text-center" primary-key="settingsId" :tbody-transition-props="transProps">
                        <template v-slot:cell(title)="row">
                            <span @click="onClickTitle(row.item, row.item.settingsId, $event.target)">
                                <a href="#" id="colored" style="text-decoration: underline;">{{ row.item.title }}</a>
                            </span>
                        </template>

                        <template v-slot:cell(buttons)="row">
                            <b-row align-v="center" class="p-0 m-0 justify-content-around" no-gutters>
                                <b-button-group vertical p-0 >
                                    <b-button variant="empty" class="header-icon btn-sm p-0" @click="moveUpItem(row.item, row.index, row.item.settingsId , $event.target  )" :disabled="row.index <= 0">
                                        <b-icon icon="chevron-up" font-scale="1.5"></b-icon>
                                    </b-button>
                                    <b-button variant="empty" class="header-icon btn-sm p-0" @click="moveDownItem(row.item, row.index , row.item.settingsId , $event.target )" :disabled="row.index >= (items.length - 1)">
                                        <b-icon icon="chevron-down" font-scale="1.5"></b-icon>
                                    </b-button>
                                </b-button-group>
                                <div class="p-0 ml-2">
                                    <b-button variant="empty" class="header-icon btn-sm p-0" @click="deleteItem(row.item, row.index , row.item.settingsId, $event.target)">
                                        <b-icon icon="trash" font-scale="1.5"></b-icon>
                                    </b-button>
                                </div>
                            </b-row>
                        </template>
                    </b-table>

                    <div class="top-right-button-container mb-2">

                    </div>
                    <b-modal id="modalbackdrop" ref="modalbackdrop" size="lg" title="예약 가능 인원 시간대 만들기" :hide-backdrop="false" :no-close-on-backdrop="true">
                        <create-headcount-settings @alwaysIs="alwaysIsMethods" :settingValue="settingValue"></create-headcount-settings>
                        <template slot="modal-footer">
                            <b-button variant="outline-primary" @click="hideModal('modalbackdrop')">취소</b-button>
                            <b-button variant="primary" @click="createHeadcountSetting('modalbackdrop')" class="mr-1">저장</b-button>
                        </template>
                    </b-modal>

                    <!--          <b-button variant="primary" class="mt-4 ml-2" @click.prevent="onSave">저장</b-button>-->

                    <div>
                        <b-button @click="registerSetting('modalbackdrop')" variant="outline-success" class="top-right-button" style="float:right;">추가
                        </b-button>
                    </div>
                </b-card>
            </template>
            <template v-else>
                <div class="loading"></div>
            </template>
        </b-colxx>
    </b-row>
    <b-button variant="outline-primary" class="mt-0" @click.prevent="goBack">뒤로</b-button>
</div>
</template>

<script>
import CreateHeadcountSettings from "./create/CreateHeadcountSettings";
import api from '../../../constants/api'
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    components: {
        'create-headcount-settings': CreateHeadcountSettings
    },
    props:{
      kakaoId:Number
    },
    data() {
        return {
            alwaysParant: "",
            userRole: null,
            isLoad: false,
            transProps: {
                name: 'list'
            },
            selectedIndex: null,
            registerPriority: 0,
            items: [],
            fields: [{
                    key: 'title',
                    label: "명칭"
                },
                {
                    key: 'period',
                    label: "기간"
                },
                {
                    key: 'targetDaysType',
                    label: "적용요일"
                },
                {
                    key: 'availableTime',
                    label: "예약가능시간"
                },
                {
                    key: 'timeUnit',
                    label: "예약단위시간"
                },
                {
                    key: 'minimumBookHeadcount',
                    label: "최소"
                },
                {
                    key: 'maximumBookHeadcount',
                    label: "최대"
                },
                {
                    key: 'totalHeadcount',
                    label: "전체"
                },
                {
                    key: 'buttons',
                    label: ""
                },
            ],
            isModifyMode: false,
            settingValue: {
                priority: null,
                storeCode: this.$route.params.storeCode,
                settingsId: null,
                title: '',
                startDate: null,
                endDate: null,
                targetDaysType: 'Everyday',
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
                inventoryTimeUnit: 'M60',
                startTime: null,
                endTime: null,
                minimumBookHeadcount: 0,
                maximumBookHeadcount: 0,
                totalHeadcount: 0,
                useInventoryAtTimeUnits: false,
                headCountAtTimeUnits: [],
                headCountAtTimeUnitsCopy: [],
            }
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },

    mounted() {
        this.userRole = this.currentUser.userRole.split('_')[0]
        this.loadData()
    },

    methods: {

        goBack() {
            this.$router.back();
        },

        /** *************************************************************************************************************/
        /** 예약가능 인원 설정 리스트 불러오기 ****************************************************************************/
        /** *************************************************************************************************************/
        loadData() {
            this.items = []
            this.registerPriority = 0;

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsList)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsListStr)
            }

            const params = {
                storeCode: this.$route.params.storeCode
            }
            this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    //

                    let vm = this;

                    res.data.data.list.forEach(function (value, index) {
                        vm.registerPriority++

                        let timeUnit = null
                        if (value.inventoryTimeUnit == "M60") {
                            timeUnit = '60분'
                        } else {
                            timeUnit = '30분'
                        }

                        let period = null
                        if (value.startDate != null && value.endDate != null) {
                            period = value.startDate + " ~ " + value.endDate
                        }

                        vm.items.push({
                            settingsId: value.settingsId,
                            title: value.title,
                            targetDaysType: vm.getTargetDaysTypeText(value),
                            period: period,
                            availableTime: value.startTime.substr(0, 5) + " ~ " + value.endTime.substr(0, 5),
                            timeUnit: '',
                            minimumBookHeadcount: value.minimumBookHeadcount,
                            maximumBookHeadcount: value.maximumBookHeadcount,
                            totalHeadcount: value.totalHeadcount,
                            timeUnit: timeUnit,
                            priority: value.priority
                        })
                    })

                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
            this.isLoad = true
        },

        //적용요일 전환
        getTargetDaysTypeText(value) {
            let custom = "";
            if (value.targetDaysType === 'Everyday') {
                return '매일'
            } else if (value.targetDaysType === 'Weekday') {
                return '주중'
            } else if (value.targetDaysType === 'Weekend') {
                return '주말'
            } else if (value.targetDaysType === 'Custom') {
                if(value.monday) {
                    if(custom == "") {
                        custom = "월";
                    } else {
                        custom += ", 월";
                    }
                }
                if(value.tuesday) {
                    if(custom == "") {
                        custom = "화";
                    } else {
                        custom += ", 화";
                    }
                }
                if(value.wednesday) {
                    if(custom == "") {
                        custom = "수";
                    } else {
                        custom += ", 수";
                    }
                }
                if(value.thursday) {
                    if(custom == "") {
                        custom = "목";
                    } else {
                        custom += ", 목";
                    }
                }
                if(value.friday) {
                    if(custom == "") {
                        custom = "금";
                    } else {
                        custom += ", 금";
                    }
                }
                if(value.saturday) {
                    if(custom == "") {
                        custom = "토";
                    } else {
                        custom += ", 토";
                    }
                }
                if(value.sunday) {
                    if(custom == "") {
                        custom = "일";
                    } else {
                        custom += ", 일";
                    }
                }
                return custom;
            }
        },

        /** *************************************************************************************************************/
        /** 예약가능 인원설정 상세모달 불러오기 ***************************************************************************/
        /** *************************************************************************************************************/
        onClickTitle(item, index, target) {

            this.settingValue.settingsId = index
            this.isModifyMode = true

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettings)
            const params = {
                settingsId: this.settingValue.settingsId
            }
            this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    // console.log("예약가능인원설정", res.data)
                    const _settingDate = res.data.data.inventorySettings
                    this.settingValue.title = _settingDate.title

                    if (_settingDate.startDate !== null) {
                        this.settingValue.startDate = new Date(_settingDate.startDate)
                    }
                    if (_settingDate.endDate !== null) {
                        this.settingValue.endDate = new Date(_settingDate.endDate)
                    }
                    this.settingValue.targetDaysType = _settingDate.targetDaysType
                    this.settingValue.monday = _settingDate.monday === true ? true : false
                    this.settingValue.tuesday = _settingDate.tuesday === true ? true : false
                    this.settingValue.wednesday = _settingDate.wednesday === true ? true : false
                    this.settingValue.thursday = _settingDate.thursday === true ? true : false
                    this.settingValue.friday = _settingDate.friday === true ? true : false
                    this.settingValue.saturday = _settingDate.saturday === true ? true : false
                    this.settingValue.sunday = _settingDate.sunday === true ? true : false
                    this.settingValue.startTime = _settingDate.startTime.substring(0, 5)
                    this.settingValue.endTime = _settingDate.endTime.substring(0, 5)
                    this.settingValue.minimumBookHeadcount = _settingDate.minimumBookHeadcount
                    this.settingValue.maximumBookHeadcount = _settingDate.maximumBookHeadcount
                    this.settingValue.totalHeadcount = _settingDate.totalHeadcount
                    this.settingValue.inventoryTimeUnit = _settingDate.inventoryTimeUnit
                    this.settingValue.useInventoryAtTimeUnits = _settingDate.useInventoryAtTimeUnits === true ? true : false
                    this.settingValue.headCountAtTimeUnits = this.changeHeadCountAtTimeUnits(_settingDate.headcountAtTimeUnits)
                    this.settingValue.headCountAtTimeUnitsCopy = this.changeHeadCountAtTimeUnits(_settingDate.headcountAtTimeUnits)
                    // this.settingValue.priority = _settingDate.priority
                    // console.log(this.settingValue)
                } else {
                    throw 400
                }

                this.$refs["modalbackdrop"].show()

            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        /** *************************************************************************************************************/
        /** 예약가능 인원설정 상세모달 신규등록 ***************************************************************************/
        /** *************************************************************************************************************/
        registerSetting(id) {
            this.clearSetting();
            this.$refs[id].show()
        },

        /** *************************************************************************************************************/
        /** 예약가능 인원설정 상세모달 저장하기 ***************************************************************************/
        /** *************************************************************************************************************/

        //parameter
        getHeadCountSettingParams() {

            let headCountAtTimeUnits = []
            this.settingValue.headCountAtTimeUnits.forEach(function (value, index) {
                const unit = {
                    headcount: value.headCount,
                    hour: Number(value.hour),
                    ahalf: value.ahalf
                }
                headCountAtTimeUnits.push(unit)
            })
            this.settingValue.headCountAtTimeUnitsCopy = this.settingValue.headCountAtTimeUnits
            // console.log(this.settingValue.headCountAtTimeUnits)

            let params = {
                inventorySettings: {
                    title: this.settingValue.title,
                    startDate: this.settingValue.startDate == undefined || this.settingValue.startDate == "Invalid Date" ?
                        null : this.$moment(this.settingValue.startDate).format('YYYY-MM-DD'),
                    endDate: this.settingValue.endDate == undefined | this.settingValue.endDate == "Invalid Date" ?
                        null : this.$moment(this.settingValue.endDate).format('YYYY-MM-DD'),
                    targetDaysType: this.settingValue.targetDaysType,
                    monday: this.settingValue.monday,
                    tuesday: this.settingValue.tuesday,
                    wednesday: this.settingValue.wednesday,
                    thursday: this.settingValue.thursday,
                    friday: this.settingValue.friday,
                    saturday: this.settingValue.saturday,
                    sunday: this.settingValue.sunday,
                    inventoryTimeUnit: this.settingValue.inventoryTimeUnit,
                    startTime: this.settingValue.startTime,
                    endTime: this.settingValue.endTime,
                    minimumBookHeadcount: this.settingValue.minimumBookHeadcount,
                    maximumBookHeadcount: this.settingValue.maximumBookHeadcount,
                    totalHeadcount: this.settingValue.totalHeadcount,
                    useInventoryAtTimeUnits: this.settingValue.useInventoryAtTimeUnits,
                    headcountAtTimeUnits: headCountAtTimeUnits
                }
            }

            // console.log(params);
            return params
        },

        createHeadcountSetting() {
            if (Number(this.settingValue.totalHeadcount) < Number(this.settingValue.minimumBookHeadcount)) {
                alert('최소 예약 가능 인원은 총 예약 가능 인원보다 클 수 없습니다.');
                this.settingValue.minimumBookHeadcount = 0;
                return false;
            }
            if (Number(this.settingValue.totalHeadcount) < Number(this.settingValue.maximumBookHeadcount)) {
                alert('최대 예약 가능 인원은 총 예약 가능 인원보다 클 수 없습니다.');
                this.settingValue.maximumBookHeadcount = 0;
                 return false;
            }
            if (this.settingValue.title === "" || this.settingValue.title === null) {
                alert('시간대 명칭을 입력해주세요.')
                return false
            } else if (this.settingValue.startTime === null) {
                alert('예약 가능 시작시간을 지정 해주세요.')
                return false
            } else if (this.settingValue.endTime === null) {
                alert('예약 가능 종료 시간을 지정 해주세요.')
                return false
            } else if (this.settingValue.minimumBookHeadcount < 1 || this.settingValue.minimumBookHeadcount === "") {
                alert('예약 겅당 최소 예약 가능 인원을 입력해주세요.')
                return false
            } else if (this.settingValue.maximumBookHeadcount < 1 || this.settingValue.maximumBookHeadcount === "") {
                alert('예약 겅당 최대 예약 가능 인원을 입력해주세요.')
                return false
            } else if (this.settingValue.totalHeadcount < 0 || this.settingValue.totalHeadcount === "") {
                alert('시간대별로 총 예약 가능 인원을 입력해주세요.')
                return false
            }
            if (this.settingValue.startTime.replace(":", "") > this.settingValue.endTime.replace(":", "")) {
                alert('예약 가능시간을 정확히 입력해 주세요.')
                return false
            }
            if (this.settingValue.minimumBookHeadcount > this.settingValue.maximumBookHeadcount) {
                alert('예약 가능 인원을 정확히 입력해 주세요.')
                return false
            }

            if (this.alwaysParant !== 'false') {
                this.settingValue.startDate = null
                this.settingValue.endDate = null
            }
            if (this.settingValue.useInventoryAtTimeUnits) {
                let headCountValidate = false
                this.settingValue.headCountAtTimeUnits.forEach(function (value, index) {
                    if (value.headCount < 0 || value.headCount === "") {
                        headCountValidate = true
                        return
                    }
                })

                if (headCountValidate) {
                    alert('시간대 별 총 에약 가능 인원수를 빈칸 없이 입력해주세요.')
                    return false
                }
            }

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsCreate)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsCreateStr)
            }

            let params = this.getHeadCountSettingParams()

            if (this.settingValue.settingsId !== null) { //수정
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsUpdate)
                params = Object.assign({
                    settingsId: this.settingValue.settingsId,
                    storeCode: this.settingValue.storeCode
                }, params)
                // params.inventorySettings = Object.assign({priority: this.settingValue.priority}, params.inventorySettings)
                // params.inventorySettings = Object.assign({priority: 3}, params.inventorySettings)

            } else { //생성
                params = Object.assign({
                    storeCode: this.settingValue.storeCode
                }, params)
                // params.inventorySettings = Object.assign({priority: this.items.length + 1}, params.inventorySettings)

            }
            // console.log(params)

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.$emit('get-kakao-alert', 'RESERVATION');
                    alert('저장되었습니다.')

                    this.$refs["modalbackdrop"].hide()

                    this.loadData()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },
        alwaysIsMethods(always) {

            this.alwaysParant = always;
        },
        /** *************************************************************************************************************/
        /** 우선순위 설정 ************************************************************************************************/
        /** *************************************************************************************************************/
        moveUpItem(item, index, settingsId, button) {
            if (index <= 0) {
                return
            }
            let preItem = this.items[index - 1];
            let clickedItem = this.items[index];
            this.items.splice(index - 1, 2, clickedItem, preItem)
            this.orderUpdate()
        },

        moveDownItem(item, index, settingsId, button) {
            if (index >= (this.items.length - 1)) {
                return
            }
            let postItem = this.items[index + 1];
            let clickedItem = this.items[index];
            this.items.splice(index, 2, postItem, clickedItem)
            this.orderUpdate()
        },

        //순서 재정의
        orderUpdate() {
            const priorities = [];
            let priority = 1;
            this.items.forEach(function (value, index) {
                priorities.push({
                    settingsId: value.settingsId,
                    priority: priority++
                })
            })

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsPriorityUpdate)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsPriorityUpdateStr)
            }

            const params = {
                priorities: priorities,
                storeCode: this.settingValue.storeCode
            }
            // console.log(params)
            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                  if(this.kakaoId) {
                    this.$emit('get-kakao-alert', 'RESERVATION');
                  }
                    alert('적용되었습니다.')
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        /** *************************************************************************************************************/
        /** 예약가능 인원 삭제 *******************************************************************************************/
        /** *************************************************************************************************************/
        deleteItem(item, index, settingsId, button) {

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsPriorityDelete)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.inventorySettingsPriorityDeleteStr)
            }

            const params = {
                settingsId: settingsId,
                storeCode: this.settingValue.storeCode
            }

            // console.log(params)

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    alert('적용되었습니다.')
                  this.$emit('get-kakao-alert', 'RESERVATION');
                    this.loadData()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        /** *************************************************************************************************************/
        hideModal(modalName) { //등록창 취소
            this.clearSetting()
            this.$refs[modalName].hide()
        },
        clearSetting() { // 등록폼 초기화
            this.settingValue.settingsId = null
            this.settingValue.title = ''
            this.settingValue.startDate = null
            this.settingValue.endDate = null
            this.settingValue.targetDaysType = 'Everyday'
            this.settingValue.monday = false
            this.settingValue.tuesday = false
            this.settingValue.wednesday = false
            this.settingValue.thursday = false
            this.settingValue.friday = false
            this.settingValue.saturday = false
            this.settingValue.sunday = false
            this.settingValue.inventoryTimeUnit = 'M60'
            this.settingValue.startTime = null
            this.settingValue.endTime = null
            this.settingValue.minimumBookHeadcount = 0
            this.settingValue.maximumBookHeadcount = 0
            this.settingValue.totalHeadcount = 0
            this.settingValue.useInventoryAtTimeUnits = false
            this.settingValue.headCountAtTimeUnits = []
            this.settingValue.headCountAtTimeUnitsCopy = [];
            this.settingValue.customDaysOfWeek = [] // 월화수목금토일
        },

        changeHeadCountAtTimeUnits(object) {
            // console.log(object)
            let result = []
            object.forEach(function (value, index) {
                if (value.ahalf === true) { //30분 단위일경우
                    result.push({
                        key: value.hour + ":" + (value.ahalf === true ? "30" : "00"),
                        hour: value.hour,
                        ahalf: value.ahalf,
                        timeUnit: value.hour + "시 " + (value.ahalf === true ? "30분" : "00분"),
                        headCount: value.headcount
                    })
                } else { //1시간 단위일경우
                    result.push({
                        key: value.hour + ":00",
                        hour: value.hour,
                        ahalf: false,
                        timeUnit: value.hour + "시 00분",
                        headCount: value.headcount
                    })
                }
            })
            return result
        }

    } //method
}
</script>

<style>
.list-move {
    transition: transform 1s;
}

.list-item {
    display: inline-block;
    margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
    transition: all 1s;
}

.list-enter,
.list-leave-to

/* .list-leave-active below version 2.1.8 */
    {
    opacity: 0;
    transform: translateY(30px);
}

.table>thead>tr>th {
    height: 50px;
    vertical-align: middle;
}

.table>tbody>tr>td {
    vertical-align: middle;
}

#colored {
    color: blue;
}
</style>
